import React, { useEffect, useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useProjectsPage, useProjectsStore } from '../state/projects';
import { SitesMap } from '../components/SitesMap';
import { LoadingAnimation } from '../components/LoadingAnimation';

export const SitesMapPage: React.FC = () => {
  const { keycloak: { token } } = useKeycloak();
  const { loadProjectsPage } = useProjectsPage();
  const { projects } = useProjectsStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (token) {
        setIsLoading(true);
        try {
          await loadProjectsPage(1);
        } catch (error) {
          console.error('Error loading projects:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    loadData();
  }, [token, loadProjectsPage]);

  if (isLoading) {
    return <LoadingAnimation />;
  }

  if (!projects || projects.length === 0) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-center">
          <div className="text-gray-500 text-lg mb-2">No projects found</div>
          <div className="text-gray-400 text-sm">Create a project to see sites on the map</div>
        </div>
      </div>
    );
  }

  return <SitesMap projects={projects} />;
}; 